module.exports = __webpack_public_path__ + "img/189.2b7c0037.jpg";